// extracted by css-extract-rspack-plugin
export default {"emojiIcon":"styles-module__emojiIcon__oIZ3B","emojiContainer":"styles-module__emojiContainer__Qedlm"};